var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$config.wcAgents.includes(_vm.$store.state.agent))?_c('LayoutHeader'):_c('detail-layout-header'),_c('div',{staticClass:"main"},[_c('router-view')],1),(!_vm.$config.wcAgents.includes(_vm.$store.state.agent))?_c('LayoutFooter'):_c('xa-layout-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }